export class Topic {
	public ID: string;
  public key: string;
  public name: string;
	public insertDate: string;
	public email: string;
  public users: string[];
  public topics: string[];
	public isDisabled: boolean = false;
	//
	public show: boolean = false;
	public edit: boolean = false;
	public checked: boolean = false;
	
	constructor(
		public hashTag: string,
		public userId: string,
		public value: string,) {
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/topic/model/topic.ts